var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5C9.38 2.5 7.25 4.63 7.25 7.25C7.25 9.82 9.26 11.9 11.88 11.99C11.96 11.98 12.04 11.98 12.1 11.99C12.12 11.99 12.13 11.99 12.15 11.99C12.16 11.99 12.16 11.99 12.17 11.99C14.73 11.9 16.74 9.82 16.75 7.25C16.75 4.63 14.62 2.5 12 2.5Z",
    fill: "#3C3939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0809 14.6499C14.2909 12.7899 9.74094 12.7899 6.93094 14.6499C5.66094 15.4999 4.96094 16.6499 4.96094 17.8799C4.96094 19.1099 5.66094 20.2499 6.92094 21.0899C8.32094 22.0299 10.1609 22.4999 12.0009 22.4999C13.8409 22.4999 15.6809 22.0299 17.0809 21.0899C18.3409 20.2399 19.0409 19.0999 19.0409 17.8599C19.0309 16.6299 18.3409 15.4899 17.0809 14.6499Z",
    fill: "#3C3939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.db96d4bd25e2b0216c6cc6204b67badb.svg";
export { ForwardRef as ReactComponent };